<div class="questionWrapper" *ngIf="showComponent">
  <span class='questionHeader'>
    <span class='questionNumberText' [innerHTML]="questionData.numberText"></span>
    <span class='questionText' [innerHTML]="questionData.text"></span>
  </span>
  <div class="p-grid answersGrid">
    <div class="p-col-12" *ngFor="let answer of questionData.answerCollection">
      <div id="answerBox" style="margin-bottom: 10px;">
        <p-radioButton [id]="questionData.id+'_'+answer.id" class="rbAnswer"
          [name]="answer.answerOptionCollection[0].id" [value]="answer.answerOptionCollection[0].id"
          [(ngModel)]="selectedAnswerOptionId" (onClick)="answerSelected($event)">
        </p-radioButton>
        <label (click)="labelClicked(answer.answerOptionCollection[0].id)" class='answerLabel'
          [for]="questionData.id+'_'+answer.id" [innerHTML]='answer.answerOptionCollection[0].text'></label>
        <input
          *ngIf="answer.answerOptionCollection[0].isFreeText && answer.answerOptionCollection[0].id===selectedAnswerOptionId"
          type="text" class='textAnswer' pInputText [(ngModel)]="selectedAnswerOptionFreeText"
          (focusout)="answerSelected($event)" />
      </div>
    </div>
  </div>
  <span class="questionFooter" [innerHTML]="questionData.footerText"></span>
</div>
